<template>
  <AdminLayout>
    <Head title="Company Users" />

    <template #pageTitle> Users </template>

    <div class="panel">
      <form
        method="POST"
        @submit.prevent=""
      >
        <div class="grid grid-cols-12 gap-6">
          <div class="input-group col-span-12 sm:col-span-6 lg:col-span-4">
            <label for="role"> Role </label>
            <input
              type="text"
              class="input-text"
              disabled
              v-model="form.role"
              name="role"
              id="role"
            />
          </div>

          <div class="input-group col-span-12 sm:col-span-6 lg:col-span-4">
            <label for="first_name"> First Name </label>
            <input
              type="text"
              class="input-text"
              disabled
              v-model="form.first_name"
              name="first_name"
              id="first_name"
            />
          </div>

          <div class="input-group col-span-12 sm:col-span-6 lg:col-span-4">
            <label for="last_name"> Last Name </label>
            <input
              type="text"
              class="input-text"
              disabled
              v-model="form.last_name"
              name="last_name"
              id="last_name"
            />
          </div>

          <div class="input-group col-span-6 sm:col-span-6 lg:col-span-6">
            <label for="phone"> Phone </label>
            <input
              type="text"
              class="input-text"
              disabled
              v-model="form.phone"
              name="phone"
              id="phone"
            />
          </div>

          <div class="input-group col-span-6 sm:col-span-6 lg:col-span-6">
            <label for="email"> Email </label>
            <input
              type="text"
              class="input-text"
              disabled
              v-model="form.email"
              name="email"
              id="email"
            />
          </div>

          <div class="input-group col-span-6 sm:col-span-6 lg:col-span-6">
            <label for="created_at"> Creation Date </label>
            <input
              type="text"
              class="input-text"
              disabled
              :value="formatDate(form.created_at)"
              name="created_at"
              id="created_at"
            />
          </div>

          <div class="input-group col-span-6 sm:col-span-6 lg:col-span-6">
            <label for="updated_at"> Updated Date </label>
            <input
              type="text"
              class="input-text"
              disabled
              :value="formatDate(form.updated_at)"
              name="updated_at"
              id="updated_at"
            />
          </div>
        </div>
      </form>
    </div>
  </AdminLayout>
</template>

<script>
import AdminLayout from '@/Layouts/AdminLayout.vue'
import { Head, Link } from '@inertiajs/vue3'
import dateFilters from '@/Mixins/dateFilters'

export default {
  mixins: [dateFilters],

  components: {
    AdminLayout,
    Head,
    Link
  },

  props: {
    user: Object
  },

  data() {
    return {
      form: {
        role: '',
        first_name: '',
        last_name: '',
        phone: '',
        email: '',
        password: '',
        password_confirmation: ''
      }
    }
  },

  created() {
    this.form = {
      ...this.form,
      ...(this.user.data || {})
    }
  }
}
</script>
